{
    "SignInWith_Title": "S'identifier avec",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Autres options"
}